"use client";

import React from "react";
import { useCookieBanner } from "cookiebanner-finally";

export function HubSpotCookieButton({
	className,
	children = "Cookie Settings",
}: {
	className?: string;
	children?: React.ReactNode;
}) {
	const { show } = useCookieBanner();

	const handleShowBanner = () => {
		// Show the cookie banner using cookiebanner-finally
		show();

		// Also trigger HubSpot's native banner if available
		if (typeof window !== "undefined" && window._hsp) {
			window._hsp.push(["showBanner"]);
		}
	};

	return (
		<button
			type="button"
			onClick={handleShowBanner}
			style={{
				backgroundColor: "",
				border: "",
				borderRadius: "3px",
				padding: "",
				textDecoration: "none",
				color: "#fff",
				fontFamily: "inherit",
				fontSize: "inherit",
				fontWeight: "normal",
				lineHeight: "inherit",
				textAlign: "left" as const,
				textShadow: "none",
				cursor: "pointer",
			}}
			className={className ?? "!text-[1.75rem]"}
		>
			{children}
		</button>
	);
}

// Extend the Window interface to include HubSpot's _hsp
declare global {
	interface Window {
		_hsp?: any[];
	}
}

